import { SET_CONFIG } from './constants';

export function setConfig(config) {
    return {
        type: SET_CONFIG,
        value: config,
    };
}
